<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<!-- {{"ADD" | translate }} {{"CADASTRO" | translate }} -->
<form [formGroup]="itemForm" (ngSubmit)="submit()">
       
<div mat-dialog-content>
  <mat-card class="p-0">
    <mat-tab-group (selectedTabChange)="setSelectedTabIndex(tabRef)" #tabRef>
      <mat-tab label="Cadastro">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100" class="pr-1">
              <br>
            </div>

            <div fxLayout="row wrap" fxLayout.lt-sm="column" class="full-width">
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['cliente']" class="full-width">Cliente
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1 ">
                <mat-slide-toggle [formControl]="itemForm.controls['fornecedor']" class="full-width">Fornecedor
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['vendedor']" class="full-width">Vendedor
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['produtor']" class="full-width">Produtor
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['funcionario']" class="full-width">Funcionário
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['trabalhador']" class="full-width">Trabalhador
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['transportador']" class="full-width">Transportadora
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['motorista']" class="full-width">Motorista
                </mat-slide-toggle>
              </div>
              <div fxFlex="33" class="pr-1">
                <mat-slide-toggle [formControl]="itemForm.controls['sindicato']" class="full-width">Sindicato
                </mat-slide-toggle>
              </div>
            </div>
            <div fxFlex="100" class="pr-1">
              <br>
            </div>

            <div fxFlex="20" class="pr-1">
              <mat-form-field class="full-width">
                <mat-select matNativeControl placeholder="Pessoa" formControlName="pessoa">
                  <mat-option value="Juridica">Jurídica</mat-option>
                  <mat-option value="Fisica">Física</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="20" class="pr-1">
              <mat-form-field class="full-width" *ngIf="itemForm.value.pessoa != 'Juridica'">
                <input [imask]="maskCpf" name="cpfCnpj" matInput type="text"
                  [formControl]="itemForm.controls['cpfCnpj']" placeholder="CPF">
              </mat-form-field>
              <mat-form-field class="full-width" *ngIf="itemForm.value.pessoa == 'Juridica'">
                <input [imask]="maskCnpj" name="cpfCnpj" matInput type="text"
                  [formControl]="itemForm.controls['cpfCnpj']" placeholder="CNPJ">
              </mat-form-field>
              <small *ngIf="itemForm.controls['cpfCnpj'].hasError('required') && itemForm.controls['cpfCnpj'].touched"
                class="form-error-msg"> CPF/CNPJ é Obrigatório </small>
              <small
                *ngIf="itemForm.controls['cpfCnpj'].hasError('validaCpfCnpj') && itemForm.controls['cpfCnpj'].touched"
                class="form-error-msg"> CPF/CNPJ Inválido </small>
            </div>

            <div fxFlex="20" class="pr-1" *ngIf="itemForm.value.pessoa == 'Juridica'">
              <!-- [disabled]="!this.cnpjIsValid(itemForm.controls['cpfCnpj'].value) || (this.counter > 0 && this.counter < 20) "  -->
              <!-- <circle-progress *ngIf="(this.counter > 0 && this.counter < 20) "
                [percent]="(this.counter*100)/20"
                [radius]="10"
               
                [showSubtitle] = 'false'
               ></circle-progress>
       -->

              <!-- <mat-progress-spinner 
                [color]="'warn'"
                [mode]="'determinate'"
                [value]="(this.counter*100)/20" diameter="25">                
            </mat-progress-spinner> -->
              <button mat-raised-button color="primary" type="button"
                (click)="this.consultaCNPJ(itemForm.controls['cpfCnpj'].value)">
                <mat-icon class="search-icon" *ngIf="!(this.counter > 0 && this.counter < 20)">search</mat-icon>
                <span *ngIf="!(this.counter > 0 && this.counter < 20)">{{"SEARCH_CNPJ_WS" | translate }}</span>
                <span *ngIf="(this.counter > 0 && this.counter < 20)">
                  Aguarde p/ consultar:{{this.counter}} Seg.
                </span>
              </button>
            </div>
            <div fxFlex="1" class="pr-1"></div>
            <div fxFlex="19" class="pr-1" *ngIf="itemForm.value.pessoa == 'Juridica'">
              <button mat-raised-button color="primary" type="button" *ngIf="this.itemForm.value.cadMun!==null 
              || this.itemForm.value.cadMun!=='undefined'"
                (click)="this.consultaCNPJCert(itemForm.controls['cpfCnpj'].value)">Pesquisar na Receita
                Estadual({{this.itemForm.value.uf}})
              </button>
            </div>
            <div fxFlex="1" class="pr-1"></div>
            <div fxFlex="9" class="pr-1">
              <mat-select [formControl]="itemForm.controls['uf']" required>
                <mat-option *ngFor="let estado of estados" [value]="estado.uf">
                  {{estado.uf}} - {{estado.estado}}
                </mat-option>
              </mat-select>
            </div>

            <!-- <div fxFlex="100" class="mt-1" *ngIf="this.cnpjReceitaWsResult2" >

              <p>Resultado da pesquisa em Receita na Receita WS:</p>
              <pre>{{this.cnpjReceitaWsResult2 | json}}</pre>

            </div>
            -->
            <div fxFlex="100" class="mt-1" *ngIf="this.cnpjReceitaResult2">
              <p>Resultado da pesquisa na Receita Estadual:</p>
              <pre>{{this.cnpjReceitaResult2 | json}}</pre>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="razaoSocial" matInput type="text"
                  [formControl]="itemForm.controls['razaoSocial']" placeholder="Nome/Razão Social">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['razaoSocial'].hasError('required') && itemForm.controls['razaoSocial'].touched"
                class="form-error-msg"> Nome/Razão Social é obrigatório </small>
            </div>

<!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [matAutocomplete]="auto" matInput type="text" name="cadCadastroGrupo"
                  formControlName="cadCadastroGrupo" placeholder="Grupo" (focus)="onFocusGrupo($event)" value="">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['cadCadastroGrupo'].hasError('required') && itemForm.controls['cadCadastroGrupo'].touched"
                class="form-error-msg"> Grupo é obrigatório </small>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnGrupo"
                (optionSelected)="onSelectionChangeGrupo($event)">
                <mat-option *ngIf="isLoadingGrupo" class="is-loading">
                  <mat-spinner diameter="30"></mat-spinner>
                </mat-option>

 
                <ng-container *ngIf="!isLoadingGrupo">
                  <mat-option *ngFor="let cadCadastroGrupo of grupos" [value]="cadCadastroGrupo">
                    <span>{{ cadCadastroGrupo.id }}</span>
                    <span> {{cadCadastroGrupo.descricao.trim()}}</span>
                  </mat-option>
                </ng-container>


                <mat-option>
                  <button mat-icon-button (click)="addGrupo()">
                    <mat-icon color="primary">add</mat-icon> adicionar grupo
                  </button>

                </mat-option>

              </mat-autocomplete>
            </div>

            <!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput matInput type="text" name="nomeFantasia"
                  [formControl]="itemForm.controls['nomeFantasia']" placeholder="Nome Fantasia">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['nomeFantasia'].hasError('required') && itemForm.controls['nomeFantasia'].touched"
                class="form-error-msg"> Nome Fantasia é obrigatório </small>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width" *ngIf="itemForm.value.pessoa == 'Juridica'">
                <input matInput name="dataNasc" type="date" formControlName="dataNasc" placeholder="Data da Fundação">
              </mat-form-field>

              <mat-form-field fxFlex="50" class="full-width" *ngIf="itemForm.value.pessoa != 'Juridica'">
                <input matInput name="dataNasc" type="date" formControlName="dataNasc" placeholder="Data de Nascimento">
              </mat-form-field>
            </div>


            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width" *ngIf="itemForm.value.pessoa != 'Juridica'">
                <input [imask]="maskUpper" matInput type="text" name="rgInscricao" formControlName="rgInscricao"
                  placeholder="RG" value="">
              </mat-form-field>
              <mat-form-field class="full-width" *ngIf="itemForm.value.pessoa == 'Juridica'">
                <input [imask]="maskUpper" matInput type="text" name="rgInscricao" formControlName="rgInscricao"
                  placeholder="Inscrição Estadual" value="">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['rgInscricao'].hasError('required') && itemForm.controls['rgInscricao'].touched"
                class="form-error-msg"> Rg/Inscrição é Obrigatório </small>
            </div>
            <div fxFlex="50" class="pr-1" *ngIf="itemForm.value.produtor">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput type="text" name="inscricaoCadPro" formControlName="inscricaoCadPro"
                  placeholder="Inscrição CAD-PRO" value="">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskFone" matInput name="celular" [formControl]="itemForm.controls['celular']"
                  placeholder="Celular">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskFone" matInput name="telefone1" [formControl]="itemForm.controls['telefone1']"
                  placeholder="Telefone Fixo">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskCep" matInput name="telefone1" [formControl]="itemForm.controls['cep']"
                  placeholder="CEP" (blur)="consultaCep($event.target.value)">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [matAutocomplete]="auto2" matInput type="text" name="cadMun" formControlName="cadMun"
                  placeholder="Cidade" (focus)="onFocus($event)" value="">
              </mat-form-field>
              <small *ngIf="itemForm.controls['cadMun'].hasError('required') && itemForm.controls['cadMun'].touched"
                class="form-error-msg"> Cidade é obrigatório </small>
              <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn"
                (optionSelected)="onSelectionChange($event)">
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="30"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let cadMun of cidades" [value]="cadMun">
                    <span>{{ cadMun.municipio.trim() }}</span>
                    <span> {{cadMun.uf.trim()}}</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput type="text" name="endereco"
                  [formControl]="itemForm.controls['endereco']" placeholder="Endereço">
              </mat-form-field>
              <small *ngIf="itemForm.controls['endereco'].hasError('required') && itemForm.controls['endereco'].touched"
                class="form-error-msg"> Endereço é obrigatório </small>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput type="text" name="numero"
                  [formControl]="itemForm.controls['numero']" placeholder="Número">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput name="bairro" [formControl]="itemForm.controls['bairro']"
                  placeholder="Bairro">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput name="complemento"
                  [formControl]="itemForm.controls['complemento']" placeholder="Complemento">
              </mat-form-field>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskEmail" type="email" name="email" [formControl]="itemForm.controls['email']"
                  placeholder="Email">
              </mat-form-field>
            </div>

          </div>
      </mat-tab>

      <mat-tab label="Resultado das consultas" *ngIf="this.cnpjReceitaResult || this.cnpjReceitaWsResult">
        <div fxFlex="100" class="mt-1">
          <p>Resultado da pesquisa em Receita WS:</p>
          <pre>{{this.cnpjReceitaWsResult | json}}</pre>
        </div>
        <div fxFlex="100" class="mt-1">
          <p>Resultado da pesquisa em Receita na Receita Estadual:</p>
          <pre>{{this.cnpjReceitaResult | json}}</pre>
        </div>

      </mat-tab>

      <!-- <mat-tab label="Diretivas de Faturamento">
        <form [formGroup]="itemForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
          </div>
        </form>
      </mat-tab> -->
      <!-- <mat-tab label="Ocorrências">

      </mat-tab> -->
      <mat-tab label="Endereços" id="mov">
        <div fxLayout="row wrap" fxLayout.lt-sm="column">
          <div fxFlex="100" class="pr-1"><br></div>
          <div fxFlex="100" class="pr-1">
            <button mat-raised-button class="mb-05" color="primary"
              (click)="$event.preventDefault(); popUpEndereco({}, true)">{{"ADD" | translate }}
              {{"ENDERECO" | translate }}</button>
            <br>
          </div>
          <div fxFlex="100" class="pr-1">

            <ngx-datatable class="material ml-0 mr-0" [rows]="enderecos" [headerHeight]="50" [footerHeight]="50"
              [scrollbarH]="true" [messages]="{emptyMessage:'Nenhum Endereço encontrado'}" [limit]="pageSizeEndereco"
               [rowHeight]="50"> <ngx-datatable-column name="#" [width]="25">
            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              <strong>{{ rowIndex+1 }}</strong>
            </ng-template>
          </ngx-datatable-column>
              <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="$event.preventDefault();popUpEndereco(row)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button mat-sm-button color="warn" (click)="$event.preventDefault();deleteEndereco(row)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="CEP" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.cep }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Endereço" [flexGrow]="1" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.endereco}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Numero" [flexGrow]="1" [width]="75">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.numero  }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Bairro" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.bairro }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Cidade" [flexGrow]="1" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="row && row.cadMun">{{ row?.cadMun?.municipio + '-' + row?.cadMun?.uf }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-footer>
                <ng-template ngx-datatable-footer-template>
                  <mat-paginator #paginatorEndereco [length]="length" fxLayoutAlign="space-around center"
                    [showFirstLastButtons]="true" [pageSize]="pageSizeEndereco"
                    [pageSizeOptions]="pageSizeOptionsEndereco"
                    (page)="pageEventEndereco = setPageSizeOptionsEndereco($event)">
                  </mat-paginator>
                </ng-template>
              </ngx-datatable-footer>
            </ngx-datatable>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Movimentações" id="mov">
        <div fxLayout="row wrap" fxLayout.lt-sm="column">

          <div fxFlex="100" class="pr-1">
            <br>
          </div>
          <div fxFlex="100" class="pr-1" *ngIf="detailsMovto && detailsMovto?.numero_lcto>0">
            <mat-chip mat-sm-chip [color]="'primary'"> TOTAL DE LCTOS: </mat-chip>&nbsp;<mat-chip mat-sm-chip
              color="accent">
              {{detailsMovto.numero_lcto}} </mat-chip>

            &nbsp;&nbsp;<mat-chip mat-sm-chip [color]="'primary'"> Data do Primeiro Lcto:</mat-chip>
            &nbsp;<mat-chip mat-sm-chip color="accent"> {{detailsMovto.data_primeiro_lcto | date:'dd/MM/yyyy' }}
            </mat-chip>
            &nbsp;&nbsp;<mat-chip mat-sm-chip [color]="'primary'">Data do Último Lcto:</mat-chip>
            &nbsp;<mat-chip mat-sm-chip color="accent"> {{detailsMovto.data_ultimo_lcto | date:'dd/MM/yyyy' }}
            </mat-chip>

          </div>
          <div fxFlex="100" class="pr-1" *ngIf="!detailsMovto || detailsMovto.numero_lcto === 0">
            <mat-chip mat-sm-chip [color]="'primary'"> Não há lançamentos registrados</mat-chip>

          </div>
          <div fxFlex="100" class="pr-1">
            <br>
          </div>

          <div fxFlex="20" class="pr-1">
            <mat-form-field class="full-width">
              <input matInput name="dataInicial" type="date" [(ngModel)]="dataInicial" placeholder="Data Inicial"
                (change)="reloadPageMovto()">
            </mat-form-field>
          </div>
          <div fxFlex="20" class="pr-1">

            <mat-form-field class="full-width">
              <input matInput name="dataFinal" type="date" [(ngModel)]="dataFinal" placeholder="Data Final"
                (change)="reloadPageMovto()">
            </mat-form-field>
          </div>

          <div fxFlex="20" class="pr-1">

            <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedOrdem" (selectionChange)="reloadPageMovto()">
                <mat-option value="NENHUM">Controle</mat-option>
                <mat-option value="TRANSACAO">Transação</mat-option>
                <mat-option value="EMISSAO">Emissão</mat-option>
                <mat-option value="ENTRADA">Entrada/Saída</mat-option>
                <mat-option value="VALOR">Total Docto</mat-option>
                <!-- <mat-option value="LOGIN">Último login</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="20" class="pr-1">
            <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedDirect" (selectionChange)="reloadPageMovto()">
                <mat-option value="ASC">Do Menor para o Maior </mat-option>
                <mat-option value="DESC">Do Maior para o Menor </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="10" class="pr-1">
            <button mat-raised-button color="primary" (click)="reloadPageMovto()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>

          <div fxFlex="100" class="pr-1">

            <ngx-datatable class="material ml-0 mr-0" [rows]="movtos" [headerHeight]="50" [footerHeight]="50"
              [scrollbarH]="true" [messages]="{emptyMessage:'Nenhuma movimentação encontrada p/ o período'}"
              [limit]="pageSize"  [rowHeight]="50"> <ngx-datatable-column name="#" [width]="25">
            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              <strong>{{ rowIndex+1 }}</strong>
            </ng-template>
          </ngx-datatable-column>
              <!-- <ngx-datatable-column name="Opções" [flexGrow]="1" [width] = "100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="openPopUp(row)"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button mat-sm-button color="warn" (click)="deleteItem(row)"><mat-icon>delete</mat-icon></button>
          </ng-template>
        </ngx-datatable-column> -->
              <ngx-datatable-column name="Controle" [flexGrow]="1" [width]="90">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.controle.toString().padStart(6, '0')}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Emissão" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.emissao | date:'dd/MM/yyyy' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Valor Lcto" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.valortotalDocto }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Transação" [flexGrow]="1" [width]="250">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.fatTransacaoCodigo +'-'+  row?.fatTransacaoDescricao }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-footer>
                <!-- <ng-template ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
                let-isVisible="isVisible">
        
                <div class="datatable-footer-inner selected-count">
                    <div class="page-count" *ngIf="selectedCount">
                        <span> {{selectedCount}} selected / </span> {{rowCount}} total
                    </div>
                    <div class="datatable-pager">
                        <ul class="pager">
                            <li class="pages active" role="button" aria-label="next" *ngIf="rowCount">
                                <a href="javascript:void(0)" (click)="LoadInfo()"> Next </a>
                            </li>
                        </ul>
                    </div>
                </div>
        
            </ng-template> -->

                <ng-template ngx-datatable-footer-template>
                  <ng-template #nocontent>
                    <p>Nenhuma movimentação encontrada p/ o período</p>
                  </ng-template>

                  <mat-paginator #paginator [length]="length" fxLayoutAlign="space-around center"
                    [showFirstLastButtons]="true" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent = setPageSizeOptions($event)">
                  </mat-paginator>
                </ng-template>

              </ngx-datatable-footer>
            </ngx-datatable>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Web">
        <div fxFlex="100" class="pr-1"><br></div>
        <div fxFlex="100" class="pr-1">
          <!-- <mat-form-field class="full-width"> -->
          <mat-checkbox name="app" [formControl]="itemForm.controls['app']">Aplicativo ?</mat-checkbox>
          <!-- </mat-form-field> -->
          <!-- <mat-form-field class="full-width">   -->
          <mat-checkbox name="lojaOnline" [formControl]="itemForm.controls['lojaOnline']">Loja Online?</mat-checkbox>
          <!-- </mat-form-field> -->
        </div>
        <div fxFlex="100" class="pr-1"><br></div>



        <div fxFlex="100" class="pr-1">
          <mat-form-field class="full-width">
            <input matInput type="text" name="urlApi" [formControl]="itemForm.controls['urlApi']"
              placeholder="URL DA API">
          </mat-form-field>

          <mat-form-field class="full-width">
            <input matInput type="text" name="urlFotoLoja" [formControl]="itemForm.controls['urlFotoLoja']"
              placeholder="FOTO DA LOJA">
            <img *ngIf="itemForm.controls['urlFotoLoja']" [src]="itemForm.controls['urlFotoLoja'].value">

          </mat-form-field>

          <mat-form-field class="full-width">
            <input matInput type="text" name="urlLogo" [formControl]="itemForm.controls['urlLogo']"
              placeholder="LOGO DA LOJA">
            <img *ngIf="itemForm.controls['urlLogo']" [src]="itemForm.controls['urlLogo'].value">

          </mat-form-field>

          <!-- <small *ngIf="itemForm.controls['urlApi'].hasError('required') && itemForm.controls['urlApi'].touched"  -->
          <!-- class="form-error-msg"> Nome Fantasia é obrigatório </small> -->
        </div>

      </mat-tab>

      <mat-tab label="Análise de Crédito">
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" [disabled]="itemForm.invalid" >{{"SAVE" | translate }}</button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">Cancelar</button>
  </div>
</form>
    
